export default __webpack_public_path__ + "static/media/profile-picture.b590eb40.jpg";